@if (player().isMe) {
  <lib-badge text="Me" type="highlight" />
}
<lib-badge
  [text]="player().retired ? 'Retired' : 'Active'"
  [type]="player().retired ? undefined : 'positive'"
/>
